import React, { useEffect, useState } from 'react'
import { Add, ConfirmationNumberOutlined, Edit } from '@material-ui/icons'
import { Button, Card, Col, Container, Form, Modal, Row, Table } from 'react-bootstrap'
import { DebounceInput } from 'react-debounce-input'
import Loading from 'components/Loading'
import TicketRequestService from 'services/ticket-request'
import { useHistory } from 'react-router-dom'
import { Trans } from 'react-i18next'
import Pagination from 'react-js-pagination'
import ChartReport from './ChartReport'
import { useUser } from 'models'

export default function () {
  const user = useUser()
  const defaultFilters = {
    per_page: 10,
    page: 1,
    search: ""
  }

  const history = useHistory()
  const [filters, setFilters] = useState(defaultFilters)
  const [isLoading, setIsLoading] = useState(false)
  const [tickets, setTickets] = useState([])
  const [pagination, setPagination] = useState([])
  const [showChartModal, setShowChartModal] = useState(false)
  const [totalTickets, setTotalTickets] = useState(0)

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };
    if (reset) f = { ...defaultFilters, ...new_filters };
    setFilters(f);
  }

  const handlePageChange = (page) => handleFilterChange({ page });

  const handleClose = () => setShowChartModal(!showChartModal)

  useEffect(() => {
    getTickets()
  }, [filters])

  const getTickets = () => {
    setIsLoading(true)
    TicketRequestService.getTickets({
      params: { ...filters }
    })
      .then((res) => {
        const { items, pagination } = res.data
        setTickets(items)
        setPagination(pagination)
      })
      .finally(() => setIsLoading(false))
  }

  return (
    <Container>
      <Row className="mt-4 d-flex align-items-end">
        <Col className="d-flex">
          <ConfirmationNumberOutlined className="icon-title" />
          <h5 className="title-dashboard">Tickets</h5>
        </Col>
      </Row>
      <Row>
        <Card.Body className="card-dashboard shadow bg-white rounded m-2 col-12">
          <Row xs="12" className='px-3 mb-3 d-flex justify-content-between'>
            {/* <Col> */}
              <Button className='btn-add'
                onClick={() => history.push("/tickets/add")}
              >
                <Add /> Criar Ticket
              </Button>
            {/* </Col>
            <Col> */}
              <button className='btn-chart' onClick={() => setShowChartModal(true)}>
                Gráfico
              </button>
            {/* </Col> */}
          </Row>
          <Row>
            <Col xs="12" md="2">
              <Form.Group>
                <Form.Label>Registros por página:</Form.Label>
                <Form.Control
                  as="select"
                  value={filters.per_page}
                  onChange={(e) =>
                    handleFilterChange({ per_page: e.target.value, page: 1 })
                  }
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col xs="12" md="3">
              <Form.Group>
                <Form.Label>Pesquisar:</Form.Label>
                <DebounceInput
                  element={Form.Control}
                  debounceTimeout={500}
                  value={filters.search}
                  onChange={(e) => {
                    handleFilterChange({ search: e.target.value, page: 1 })
                  }}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs="12" md="12">
              {isLoading ? (<Loading page />) : (
                <Table
                  striped
                  bordered
                >
                  <thead>
                    <tr className='text-center'>
                      <th>Numero</th>
                      <th>Status</th>
                      <th>Assunto</th>
                      <th>Solicitante</th>
                      <th>Responsavel</th>
                      <th>Data Solicitacao</th>
                      <th>Categoria</th>
                      <th>Prioridade</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {tickets.map(ticket => {
                      return (
                        <tr key={ticket.id} className='text-center'>
                          <td>{ticket.number}</td>
                          <td>{ticket.status}</td>
                          <td>{ticket.subject}</td>
                          <td>{ticket.requester}</td>
                          <td>{ticket.assignee ?? "--"}</td>
                          <td>{new Date(ticket.created_at).toLocaleDateString("pt-br")}</td>
                          <td>{ticket.type}</td>
                          <td>{ticket.priority}</td>
                          <td>
                            <Button
                              size="sm"
                              className="btn-add mr-1"
                              onClick={() => history.push(`/tickets/${ticket.id}/edit`)}
                            >
                              <Edit />
                            </Button>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              )}
              <Row>
                <Col xs="12" md="6">
                  <Trans i18nKey="label:interpolateShowingRecords">
                    Showing {{ from: pagination.from || '0' }} to{' '}
                    {{ to: pagination.to || '0' }} from{' '}
                    {{ total: pagination.total }} records
                  </Trans>
                </Col>
                <Col xs="12" md="6" className="d-flex justify-content-end">
                  <Pagination
                    activePage={pagination.current_page}
                    itemsCountPerPage={parseInt(pagination.per_page)}
                    totalItemsCount={pagination.total ?? 0}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    itemClass="page-item"
                    linkClass="page-link"
                    prevPageText="‹"
                    nextPageText="›"
                  />
                </Col>
              </Row>
            </Col>

          </Row>
        </Card.Body>
      </Row>

      <Modal dialogClassName='my-modal-90' centered show={showChartModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Gráfico - Total de tickets: {totalTickets}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ChartReport setTotalTickets={setTotalTickets}/>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Save Changes
          </Button>
        </Modal.Footer> */}
      </Modal>
    </Container>
  )
}